import { useState } from "react";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import Button from "ui/buttons/Button";

## Basic Usage

export function BasicDeleteModal() {
  const [open, setOpen] = useState(false);
  const handleConfirm = async (e) => {
    e.preventDefault();
    alert("Deleted!");
    setOpen(false);
  };
  return (
    <>
      <Button btnStyle="remove" onClick={() => setOpen(true)}>Delete Project</Button>
      {open && (
        <ConfirmDeleteModal
          onClose={() => setOpen(false)}
          onConfirm={handleConfirm}
          entityName="My Project"
          entityType="project"
          message="This will permanently delete the project and all associated data."
        />
      )}
    </>
  );
}

<BasicDeleteModal />

Type the entity name to enable the delete button.

---

## Without Name Entry Requirement

export function SimpleDeleteModal() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button btnStyle="remove" onClick={() => setOpen(true)}>Delete Item</Button>
      {open && (
        <ConfirmDeleteModal
          onClose={() => setOpen(false)}
          onConfirm={(e) => { e.preventDefault(); alert("Deleted!"); setOpen(false); }}
          entityType="item"
          message="Are you sure you want to delete this item?"
          requireEntityNameEntry={false}
        />
      )}
    </>
  );
}

<SimpleDeleteModal />

---

## Reversible Deletion

export function ReversibleDeleteModal() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button btnStyle="remove" onClick={() => setOpen(true)}>Archive Document</Button>
      {open && (
        <ConfirmDeleteModal
          onClose={() => setOpen(false)}
          onConfirm={(e) => { e.preventDefault(); alert("Archived!"); setOpen(false); }}
          entityName="Important Document"
          entityType="document"
          message="This document will be moved to the archive. You can restore it later."
          canRevert
        />
      )}
    </>
  );
}

<ReversibleDeleteModal />

The warning message is hidden when `canRevert` is true.

---

## Deleting Multiple Items

export function DeleteManyModal() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button btnStyle="remove" onClick={() => setOpen(true)}>Delete Selected (3)</Button>
      {open && (
        <ConfirmDeleteModal
          onClose={() => setOpen(false)}
          onConfirm={(e) => { e.preventDefault(); alert("Deleted!"); setOpen(false); }}
          entityName="3 items"
          entityType="items"
          message={
            <div>
              <p>You are about to delete 3 items:</p>
              <ul style={{ margin: "0.5rem 0", paddingLeft: "1.5rem" }}>
                <li>Document A</li>
                <li>Document B</li>
                <li>Document C</li>
              </ul>
            </div>
          }
          isMany
        />
      )}
    </>
  );
}

<DeleteManyModal />

---

## Deleting State

export function DeletingStateModal() {
  const [open, setOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const handleConfirm = async (e) => {
    e.preventDefault();
    setIsDeleting(true);
    await new Promise((resolve) => setTimeout(resolve, 2000));
    setIsDeleting(false);
    setOpen(false);
    alert("Deleted!");
  };
  return (
    <>
      <Button btnStyle="remove" onClick={() => setOpen(true)}>Delete with Loading</Button>
      {open && (
        <ConfirmDeleteModal
          onClose={() => setOpen(false)}
          onConfirm={handleConfirm}
          entityType="item"
          message="This will delete the item."
          requireEntityNameEntry={false}
          isDeleting={isDeleting}
        />
      )}
    </>
  );
}

<DeletingStateModal />

